import { motion } from "framer-motion";

const CHAPTERS = [
  {
    n: "01",
    title: "Independent, not captive.",
    body: "We aren't tied to a single carrier. That means we shop the market for you and recommend the plan that fits your life — not a sales quota.",
  },
  {
    n: "02",
    title: "Plain language, always.",
    body: "Riders, elimination periods, MOOPs. We translate the fine print into decisions you can actually make with confidence.",
  },
  {
    n: "03",
    title: "A licensed human answers.",
    body: "You'll work with a real, state-licensed producer from first quote to claim time — the same person, every time you call.",
  },
  {
    n: "04",
    title: "No cost, no pressure.",
    body: "Our guidance is free; carriers pay us. You decide if and when to enroll, through official, secure application portals.",
  },
];

const IMG =
  "https://images.pexels.com/photos/12013184/pexels-photo-12013184.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1000";

export default function Manifesto() {
  return (
    <section id="about" className="bg-warm-white py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-14">
          {/* left sticky intro + image */}
          <div className="lg:col-span-5">
            <div className="lg:sticky lg:top-28">
              <p className="eyebrow text-gold mb-4 flex items-center gap-3">
                <span className="inline-block w-8 h-px bg-gold" /> About Us
              </p>
              <h2 className="font-heading font-extrabold tracking-tighter text-navy text-[clamp(2rem,4.5vw,3.6rem)] leading-[1]">
                Our promise, in four principles.
              </h2>
              <p className="mt-5 text-brand-slate leading-relaxed max-w-md">
                {`WF Services is an independent agency built on one idea: insurance should
                be honest, understandable, and centered on the people it protects.`}
              </p>
              <div className="mt-8 clip-frame overflow-hidden rounded-xl border border-black/[0.07]">
                <img src={IMG} alt="A senior couple enjoying retirement together"
                  className="w-full h-[300px] object-cover" loading="lazy" />
              </div>
            </div>
          </div>

          {/* right chapters */}
          <div className="lg:col-span-7 lg:pt-4">
            <div className="divide-y divide-black/[0.08]">
              {CHAPTERS.map((c, i) => (
                <motion.div
                  key={c.n}
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true, margin: "-80px" }}
                  transition={{ duration: 0.6, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
                  data-testid={`manifesto-${c.n}`}
                  className="relative py-10 flex gap-6 sm:gap-10"
                >
                  <span className="font-heading font-extrabold text-[3.5rem] sm:text-[4.5rem] leading-none stroke-text shrink-0 select-none">
                    {c.n}
                  </span>
                  <div className="pt-2">
                    <h3 className="font-heading font-bold text-navy text-2xl">{c.title}</h3>
                    <p className="mt-3 text-brand-slate leading-relaxed max-w-lg">{c.body}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
